import { render, staticRenderFns } from "./LightingItem.vue?vue&type=template&id=4332286b&scoped=true"
import script from "./LightingItem.vue?vue&type=script&lang=js"
export * from "./LightingItem.vue?vue&type=script&lang=js"
import style0 from "./LightingItem.vue?vue&type=style&index=0&id=4332286b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4332286b",
  null
  
)

export default component.exports